import { featureActive, FEATURES } from 'lib/features/index';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { useDispatch} from "react-redux";
import { modalSet } from "_slices/view";
import { useContext } from "react";
import Link from "next/link";
import { Context } from 'context/context';
import styles from './pricing.module.css'
import { useRouter } from 'next/navigation'

type MetadataType = {
    sku: string
}

type PricingType = {
    content: string[];
    buttonText?: string;
    metadata: MetadataType;
    name: string;
    notIncludes: string[];
    popular: boolean;
    price: any;
    stripe_id: string;
}

interface PricingProps {
    pricing: PricingType,
    pricingType: string,
    onSelectProduct: any
}

interface OriginalPricingProps {
    pricing: PricingType,
    pricingType: string,
}


const OriginalPricing = ({ pricing, pricingType }: OriginalPricingProps) => {
    return <div className={styles.PricingContainer} key={pricing.name} style={{ borderRadius: pricing.popular ? '0px 0px 5px 5px' : '5px', marginTop: pricing.popular ? '40px' : '0px' }} >
        {pricing.popular && <div className={styles.PopularPricing}>Popular</div>}
        <div className={styles.PricingHeader}>
            {pricing.name}
        </div>
        <div className={styles.divider} />
        <h3 className={styles.pricing} >
            £{pricingType === 'month' ? pricing.price.month.formatted_price : pricing.price.year.formatted_price}<span>{pricingType === 'month' ? 'pcm' : 'pa'}</span>
        </h3>
        <ul>
            {pricing.content.map((content: string,) => {
                return <li key={`${pricing.name}-${content}`} ><CheckCircleOutlineRoundedIcon sx={{ color: 'green' }} /><p>{content}</p></li>
            })}

            {pricing.notIncludes.map((content: string) => {
                return <li key={`${pricing.name}-${content}`} ><CancelRoundedIcon sx={{ color: 'red' }} /><p className={styles.notIncluded}>{content}</p></li>
            })}
        </ul>
        <Link prefetch={false} href="#contactForm">
            <button className={styles.tableButton}>
                {pricing.buttonText ?? 'Get Started'}
            </button>
        </Link>
    </div>

}


const Pricing = ({ pricing, pricingType, onSelectProduct = () => { } }: PricingProps) => {
    let dispatch = useDispatch();

    const router = useRouter()

    const { state } = useContext(Context);

    const subscriptionEnabled = featureActive(FEATURES.SUBSCRIPTIONS, null);
    const loggedIn = state?.user?.loggedIn

    // If the subscription feature is not active just return the original form.
    if (!subscriptionEnabled) {
        return (
            <OriginalPricing pricing={pricing} pricingType={pricingType} />
        )
    }

    const buttonHandler = (pricing) => {
        if (!loggedIn) {
            dispatch(modalSet({ visible: true, type: "auth", view: "login", }))
            return
        }

        const period = pricingType === 'month' ? 'month' : 'year'
        const price_id = pricing?.price?.[period].id;
        const sku = pricing?.metadata?.sku;
        router.push(`/checkout/${sku}/${period}`)

        try {
            onSelectProduct({ price_id, sku, period })
        } catch (error) {

        }
    }

    // are we logged in
    return <div className={styles.PricingContainer} key={pricing.name} style={{ borderRadius: pricing.popular ? '0px 0px 5px 5px' : '5px', marginTop: pricing.popular ? '40px' : '0px' }} >
        {pricing.popular && <div className={styles.PopularPricing}>Popular</div>}
        <div className={styles.PricingHeader}>
            {pricing.name}
        </div>
        <div className={styles.divider} />
        <h3 className={styles.pricing} >
            £{pricingType === 'month' ? pricing.price.month.formatted_price : pricing.price.year.formatted_price}<span>{pricingType === 'month' ? 'pcm' : 'pa'}</span>
        </h3>
        <ul>
            {pricing.content.map((content: string,) => {
                return <li key={`${pricing.name}-${content}`} ><CheckCircleOutlineRoundedIcon sx={{ color: 'green' }} /><p>{content}</p></li>
            })}

            {pricing.notIncludes.map((content: string) => {
                return <li key={`${pricing.name}-${content}`} ><CancelRoundedIcon sx={{ color: 'red' }} /><p className={styles.notIncluded}>{content}</p></li>
            })}
        </ul>
        <button className={styles.tableButton} onClick={() => buttonHandler(pricing)}>
            {loggedIn ? 'Select plan' : 'Get started'}
        </button>
    </div>

}

export default Pricing;
